import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
export function FinalCTA() {
  return <section className="relative py-16 sm:py-28 lg:py-40 bg-[#0a0a0a] overflow-hidden" data-id="element-115">
      {/* Subtle Background Texture */}
      <div className="absolute inset-0 z-0" data-id="element-116">
        <img src="https://images.unsplash.com/photo-1626265774643-f1943311a86b?q=80&w=2000&auto=format&fit=crop" alt="Dark corridor texture" className="w-full h-full object-cover opacity-15 filter contrast-125 saturate-50" data-id="element-117" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0a] via-[#0a0a0a]/80 to-[#0a0a0a]" data-id="element-118" />
        <div className="absolute inset-0 bg-noise mix-blend-overlay opacity-20" data-id="element-119" />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-120">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 1,
        ease: [0.16, 1, 0.3, 1]
      }} className="space-y-6 sm:space-y-10" data-id="element-121">
          <h2 className="font-typewriter text-3xl sm:text-6xl text-[#ece3d0] drop-shadow-2xl" data-id="element-122">
            One download.
            <br data-id="element-123" />
            One night.
            <br data-id="element-124" />
            Zero regrets.
          </h2>

          <div className="space-y-1.5 sm:space-y-2 font-serif-body text-lg sm:text-2xl text-[#ece3d0]/80 italic" data-id="element-125">
            <p data-id="element-126">The cases are waiting.</p>
            <p data-id="element-127">The files are ready.</p>
            <p className="text-[#8b1a1a] font-bold text-xl sm:text-3xl pt-2 sm:pt-4 not-italic font-typewriter uppercase tracking-wider" data-id="element-128">
              The only thing missing is you.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 pt-6 sm:gap-6 sm:pt-10" data-id="element-129">
            <button className="border border-[#ece3d0]/30 hover:border-[#ece3d0]/60 text-[#ece3d0] px-6 py-3.5 sm:px-8 sm:py-5 rounded font-typewriter font-bold tracking-wider transition-all hover:scale-105 w-full sm:w-auto text-sm sm:text-lg backdrop-blur-sm bg-[#0a0a0a]/50 hover:bg-[#0a0a0a]/80" data-id="element-130">
              START WITH ONE CASE — $17
            </button>
            <button className="bg-[#8b1a1a] hover:bg-[#a01f1f] text-[#ece3d0] px-6 py-3.5 sm:px-8 sm:py-5 rounded font-typewriter font-bold tracking-wider transition-all hover:scale-105 w-full sm:w-auto text-sm sm:text-lg shadow-[0_0_30px_rgba(139,26,26,0.4)] border border-[#a01f1f]" data-id="element-131">
              GET ALL FOUR CASES — $42
            </button>
          </div>

          {/* Repeated Social Proof for Bottom Funnel */}
          <div className="pt-8 sm:pt-16 flex flex-col items-center space-y-3" data-id="element-132">
            <div className="flex items-center space-x-1 text-yellow-600 drop-shadow-md" data-id="element-133">
              {[1, 2, 3, 4, 5].map(star => <StarIcon key={star} className="w-5 h-5 fill-current" data-id="element-134" />)}
            </div>
            <p className="font-serif-body text-[#ece3d0]/80 text-base sm:text-lg" data-id="element-135">
              Join over{' '}
              <span className="text-[#ece3d0] font-semibold" data-id="element-136">
                1,000+ detectives
              </span>{' '}
              who cracked the case.
            </p>
          </div>

          <div className="pt-8 sm:pt-12 text-xs sm:text-sm text-[#ece3d0]/40 space-y-1 font-typewriter uppercase tracking-widest" data-id="element-137">
            <p data-id="element-138">
              Instant digital download. PDF format. Compatible with all devices.
            </p>
            <p data-id="element-139">
              Print at home or play on screen. One purchase, unlimited plays.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}